
import React from 'react';
import type { IFileDto } from '../types/interfaces/IFileDto';
import { getUri_GetFile } from './ApiUriService';

interface FileServiceProps {
  fileDto: IFileDto;
}

export async function handleDownload(fileDto: IFileDto) {
  if (!fileDto.fileName) return;
  const url = getUri_GetFile();
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(fileDto),
    });
    if (!response.ok) {
      throw new Error('Failed to download file.');
    }
    const blob = await response.blob();
    if (blob.size === 0) {
      throw new Error('Downloaded file is empty.');
    }
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileDto.fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(objectUrl);
  } catch (error) {
    alert('Error downloading file: ' + (error instanceof Error ? error.message : error));
  }
}